import { useEffect, useRef } from 'react';
import ApexCharts from 'apexcharts';

const SizeMixedChart = () => {
    const chartRef = useRef<HTMLDivElement>(null);
    const chartInstance = useRef<ApexCharts | null>(null);

    useEffect(() => {
        if (!chartRef.current) return;

        const options = {
            series: [
                {
                    name: '기온 (°C)',
                    type: 'column',
                    data: [
                        12, 11, 10, 10, 11, 13, 15, 17, 19, 21, 23, 24, 25, 24,
                        23, 22, 20, 18, 16, 15, 14, 13, 13, 12,
                    ],
                },
                {
                    name: '강수량 (mm)',
                    type: 'area',
                    data: [
                        0, 0, 0, 0, 0, 0.5, 1.2, 2.5, 3.8, 2.1, 1.0, 0.3, 0, 0,
                        0, 0, 0.8, 1.5, 2.8, 4.2, 2.5, 1.2, 0.4, 0,
                    ],
                },
            ],
            chart: {
                type: 'area',
                height: 243,
                toolbar: {
                    show: false,
                },
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                curve: ['smooth', 'smooth'],
                dashArray: [0, 3],
                width: [0, 1],
            },
            plotOptions: {
                bar: {
                    columnWidth: '50%',
                    borderRadius: 6,
                },
            },
            colors: ['rgb(98,230,62)', 'rgb(94,164,244)'],
            fill: {
                type: ['solid', 'gradient'],
                gradient: {
                    shade: 'dark',
                    shadeIntensity: 0.1,
                    inverseColors: false,
                    gradientToColors: ['rgb(25,100,186)', 'rgb(82,106,228)'],
                    opacityFrom: [1, 0.4],
                    opacityTo: [1, 0.5],
                    stops: [0, 90, 100],
                },
            },
            grid: {
                borderColor: '#f1f1f1',
                strokeDashArray: 3,
            },
            labels: [
                '0시',
                '1시',
                '2시',
                '3시',
                '4시',
                '5시',
                '6시',
                '7시',
                '8시',
                '9시',
                '10시',
                '11시',
                '12시',
                '13시',
                '14시',
                '15시',
                '16시',
                '17시',
                '18시',
                '19시',
                '20시',
                '21시',
                '22시',
                '23시',
            ],
            xaxis: {
                labels: {
                    style: {
                        fontSize: '11px',
                    },
                },
            },
            yaxis: [
                {
                    title: {
                        text: '기온 (°C)',
                        style: {
                            fontSize: '12px',
                        },
                    },
                    labels: {
                        formatter: val => `${val}°`,
                    },
                },
                {
                    opposite: true,
                    title: {
                        text: '강수량 (mm)',
                        style: {
                            fontSize: '12px',
                        },
                    },
                    labels: {
                        formatter: val => `${val}mm`,
                    },
                    min: 0,
                    max: 10,
                },
            ],
            tooltip: {
                shared: true,
                intersect: false,
                y: [
                    {
                        formatter: val => `${val}°C`,
                    },
                    {
                        formatter: val => `${val}mm`,
                    },
                ],
            },
        };

        chartInstance.current = new ApexCharts(chartRef.current, options);
        chartInstance.current.render();

        return () => {
            if (chartInstance.current) {
                chartInstance.current.destroy();
            }
        };
    }, []);

    return (
        <>
            <div ref={chartRef} style={{}}></div>
        </>
    );
};

export default SizeMixedChart;
